module.exports = __webpack_public_path__ + "img/slimfit.bd1ff186.svg";